module.exports = __webpack_public_path__ + "static/media/112-laos.38185ab9.svg";